"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("../core");
exports.Indicator = function (_a) {
    var onClick = _a.onClick, isActive = _a.isActive;
    return (react_1.default.createElement(core_1.Box, { as: "li", style: { cursor: "pointer", listStyle: "none" }, m: "2px", p: "5px", onClick: onClick },
        react_1.default.createElement(core_1.Box, { width: "10px", height: "10px", borderRadius: "50%", bg: "#000", transition: "transform 0.3", style: {
                transform: "scale(" + (isActive ? "1.4" : "1") + ")"
            } })));
};
